import { Component, OnInit } from '@angular/core'
import {
  AuthService,
  GlobalMessageService,
  TranslationService,
} from '@spartacus/core'
import { BreadcrumbService } from '../../../../shared/components/breadcrumb/breadcrumb.service'
@Component({
  standalone: false,
  selector: 'vs-feedback-form',
  templateUrl: './feedback-form.component.html',
  styleUrls: ['./feedback-form.component.scss'],
})
export class FeedbackFormComponent implements OnInit {
  isLoggedinUser = false
  userType: string
  constructor(
    private auth: AuthService,
    private breadCrumbService: BreadcrumbService,
    private translate: TranslationService,
    private globalMessageService: GlobalMessageService
  ) {}

  ngOnInit(): void {
    this.breadCrumbService.setBreadCrumbs([])
    this.translate
      .translate('help.feedbackForm')
      .subscribe((res: string) =>
        this.breadCrumbService.setBreadcrumbTitle(res)
      )

    this.auth.isUserLoggedIn().subscribe((success) => {
      if (success) {
        this.isLoggedinUser = success
        this.userType = 'current'
      } else {
        this.userType = 'anonymous'
      }
    })
  }
}
